<div id="theme-wrapper">
  <app-action-less-header *ngIf="!showHeaderNav"></app-action-less-header>
  <ng-container *ngIf="showHeaderNav">
    <app-header *ngIf="!userActive"></app-header>
    <app-user-header *ngIf="userActive"></app-user-header>
  </ng-container>
  <div id="page-wrapper" class="container-fluid"
    [class.p-0]="showHeaderNav"
    [style.padding-left]="showHeaderNav ? '10px' : null"
    [class.nav-small]="userActive">
    <ui-view></ui-view>
  </div>
  <app-footer *ngIf="showHeaderNav"></app-footer>
</div>
<div id="loading-modal">
  <span id="loading-modal-content"></span>
</div>
